import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";
import { InvitacionTrabajoDTO } from "app/main/apps/shared/models/invitacion-trabajo.model";
import { config as CONFIG } from "app/app.config";
import { OrdenesDeTrabajoService } from "app/main/apps/shared/services/rest/ordenes-de-trabajo.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { Subscription } from "rxjs";

import { finalize } from "rxjs/operators";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

@Component({
    selector: "app-dialog-invitar",
    templateUrl: "./dialog-invitar.component.html",
    styleUrls: ["./dialog-invitar.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogInvitarComponent implements OnInit, OnDestroy {
    procesando: boolean = false;
    formInvitacion: FormGroup;
    config;
    subscripciones: Subscription;
    mostrarAvisoMontoOfertado: boolean;
    constructor(
        public dialogRef: MatDialogRef<DialogInvitarComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            contratistas: ContratistaDTO[];
            idOOTT: number;
            valorCotizado: number;
        },
        private _fb: FormBuilder,
        private _oottSrvc: OrdenesDeTrabajoService,
        private _notificacionesSrvc: NotificacionesService,
        private customValidators: ValidadoresFormularioService
    ) {
        this.mostrarAvisoMontoOfertado = false;
        this.subscripciones = new Subscription();
        this.config = CONFIG;
    }

    ngOnInit(): void {
        //console.log(this.data);
        this.initForm();
    }

    initForm() {
        this.formInvitacion = this._fb.group({
            montoOfertado: [
                null,
                {
                    validators: [
                        Validators.required,
                        Validators.min(0),
                        Validators.pattern(
                            this.customValidators.regexSoloNumeros
                        ),
                    ],
                },
            ],
            fechaVigencia: [null, { validators: [Validators.required] }],
            horaVigencia: [
                null,
                {
                    validators: [
                        Validators.required,
                        Validators.pattern(
                            this.customValidators.regexFormatoHora
                        ),
                    ],
                },
            ],
            rango: this._fb.group({
                fechaInicioTrabajo: [
                    null,
                    { validators: [Validators.required] },
                ],
                fechaTerminoTrabajo: [
                    null,
                    { validators: [Validators.required] },
                ],
            }),
            incluyeMateriales: [true],
        });

        this.agregaMonitoreoACampos();
    }
    agregaMonitoreoACampos() {
        this.montoOfertado.valueChanges.subscribe(
            (valor) =>
                (this.mostrarAvisoMontoOfertado =
                    valor > this.data.valorCotizado)
        );
    }

    get rango() {
        return this.formInvitacion.get("rango");
    }
    get montoOfertado() {
        return this.formInvitacion.get("montoOfertado");
    }

    get fechaVigencia() {
        return this.formInvitacion.get("fechaVigencia");
    }

    get horaVigencia() {
        return this.formInvitacion.get("horaVigencia");
    }

    get fechaInicioTrabajo() {
        return this.formInvitacion.get("rango").get("fechaInicioTrabajo");
    }

    get fechaTerminoTrabajo() {
        return this.formInvitacion.get("rango").get("fechaTerminoTrabajo");
    }

    get incluyeMateriales() {
        return this.formInvitacion.get("incluyeMateriales");
    }

    generarInvitacionTrabajo() {
        this.procesando = true;
        //console.log(this.horaVigencia.value);
        const rutContratistas = this.data.contratistas.map(
            (contratista) => contratista.nrRut
        );
        const invitacionTrabajo = new InvitacionTrabajoDTO(
            this.montoOfertado.value,
            this.incluyeMateriales.value || false,
            this.fechaInicioTrabajo.value.toISOString().split("T")[0],
            this.fechaTerminoTrabajo.value.toISOString().split("T")[0],
            this.fechaVigencia.value.toISOString().split("T")[0] +
                "T" +
                this.horaVigencia.value +
                ":00",

            rutContratistas
        );
        //console.log(invitacionTrabajo);
        this.subscripciones.add(
            this._oottSrvc
                .generaInvitacionesContratistas(
                    this.data.idOOTT,
                    invitacionTrabajo
                )
                .pipe(
                    finalize(() => {
                        this.procesando = false;
                    })
                )
                .subscribe((resp) => {
                    this._notificacionesSrvc.mostrarNotificacion(
                        "Invitación enviada",
                        "success"
                    );
                    this.dialogRef.close();
                })
        );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
